import "./LiveAnnouncements.css";

export type LiveAnnouncementsProps = {
  /** One coalesced summary for the most recently completed transition. */
  readonly turnSummary?: string;
  /** Terminal text replaces, rather than compounds, the ordinary turn summary. */
  readonly terminalSummary?: string;
  /** Kept separate so repeated bot status cannot overwrite direct interaction feedback. */
  readonly botStatus?: string;
};

export function LiveAnnouncements({
  turnSummary = "",
  terminalSummary = "",
  botStatus = "",
}: LiveAnnouncementsProps) {
  return (
    <div className="live-announcements">
      <div className="live-announcements__visually-hidden" role="status" aria-atomic="true">
        {terminalSummary || turnSummary}
      </div>
      <div
        className="live-announcements__visually-hidden"
        role="status"
        aria-atomic="true"
        data-status="bot"
      >
        {botStatus}
      </div>
    </div>
  );
}
